module.exports = __webpack_public_path__ + "img/markit-meals2.17cedfc7.png";